import { Children } from 'react';

const l=o=>{let e=null,n=null;return Children.forEach(o.children,r=>{r.props.isTrue===void 0?n=r:r.props.isTrue&&(e||(e=[]),e.push(r));}),e||n};l.When=({isTrue:o,children:e})=>o&&e?e:null;l.Else=({render:o,children:e})=>o||e||null;

export { l as Show };
//# sourceMappingURL=contact-channels95.js.map
